var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import Theme from 'Theme';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.message = undefined;
        this.loading = [];
        this.isDesktop = false;
        this.constructString = function (data) {
            var route = data.url
                // .slice(data.baseURL!.length)
                .replace(/^([a-z\/]+).*$/, '$1')
                .replace(/\/$/, '');
            var result = data.method + '@' + route + '/';
            return result;
        };
        this.createLoading = function (data) {
            _this.loading.push(_this.constructString(data));
        };
        this.removeLoading = function (data) {
            if (!data)
                _this.loading = [];
            else {
                var index = _this.loading.indexOf(_this.constructString(data));
                if (index > -1) {
                    _this.loading.splice(index, 1);
                }
            }
        };
        this.isLoading = function (request) {
            if (!request)
                return false;
            var requests = Array.isArray(request) ? request : [request];
            return _this.loading.some(function (e) { return requests.includes(e); });
        };
        this.changeMenuSelected = function (nuevo) {
            _this.menuSelected = nuevo;
            _this.menuSelectedConfiguracion = '';
        };
        this.changeMenuSelectedConfiguracion = function (nuevo) {
            _this.menuSelectedConfiguracion = nuevo;
        };
        this.changeMenuSelectedOperaciones = function (nuevo) {
            _this.menuSelectedOperaciones = nuevo;
        };
        this.setMessage = function (text, type) {
            if (type && text) {
                _this.message = { text: text, type: type };
                _this.hideMessage();
            }
            else
                _this.message = undefined;
        };
        this.setIsDesktop = function () {
            _this.isDesktop = /*!this.isMobileDevice()*/
                window.innerWidth >= Theme.common.devices.desktopWidth &&
                    window.innerHeight >= Theme.common.devices.mobileHeight;
        };
        this.hideMessage = function () {
            setTimeout(function () {
                _this.setMessage();
            }, 3000);
        };
        window.addEventListener('resize', this.setIsDesktop);
        this.setIsDesktop();
    }
    default_1.prototype.newWarning = function (text) {
        this.setMessage(text, 'warning');
    };
    default_1.prototype.newError = function (text) {
        this.setMessage(text, 'error');
    };
    default_1.prototype.isMobileDevice = function () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };
    __decorate([
        observable
    ], default_1.prototype, "message", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "isDesktop", void 0);
    __decorate([
        observable
    ], default_1.prototype, "menuSelected", void 0);
    __decorate([
        observable
    ], default_1.prototype, "menuSelectedConfiguracion", void 0);
    __decorate([
        observable
    ], default_1.prototype, "menuSelectedOperaciones", void 0);
    __decorate([
        action
    ], default_1.prototype, "createLoading", void 0);
    __decorate([
        action
    ], default_1.prototype, "removeLoading", void 0);
    __decorate([
        action
    ], default_1.prototype, "changeMenuSelected", void 0);
    __decorate([
        action
    ], default_1.prototype, "changeMenuSelectedConfiguracion", void 0);
    __decorate([
        action
    ], default_1.prototype, "changeMenuSelectedOperaciones", void 0);
    __decorate([
        action
    ], default_1.prototype, "setMessage", void 0);
    __decorate([
        action
    ], default_1.prototype, "setIsDesktop", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/UI/Store.ts
// module id = 692
// module chunks = 0